import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Col, Row, Button, Form, FormGroup, Label, Input, Spinner } from 'reactstrap';
import { DropDownList} from '@progress/kendo-react-dropdowns';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { Slider, SliderLabel} from '@progress/kendo-react-inputs';
import { FeaturedListings} from './FeaturedListings';
import { Fade} from '@progress/kendo-react-animation';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';

@inject("mobxStore")
@observer
export class Search extends Component {

  constructor (props) {
    super(props);

    this.state = {
        type: 'Residential',
        priceRange: '',
        minBedrooms: 3,
        minBathrooms: 2,
        waterFront: false,
        posting: false
    };

    this.prices = ['', '$0 to $200,000', '$200,000 to $400,000', '$400,000 to $600,000', '$600,000 to $800,000', '$800,000 to $1.2M', '> $1,200,000'];
  }
  componentDidMount() {
    ReactGA.set({ page: 'Search' });
    ReactGA.pageview('/search');
  }

  SearchProperties = () => {
    const {type, priceRange, minBedrooms, minBathrooms, waterFront} = this.state;
    const params = {
        pType: type,
        priceRange,
        minBedrooms: Math.round(minBedrooms),
        minBathrooms: Math.round(minBathrooms),
        waterFront
      };

    this.setState({posting: true});

    this.props.mobxStore.searchProperties(params);
  }

  render () {
    const publicUrl = process.env.PUBLIC_URL;
    const {featuredPres, posting} = this.props.mobxStore;

    return (
        <div className="container">
            <div className="pt-4 text-center">
                <h5 className="d-inline-block ml-3 mb-3" style={{color: '#333333'}}>Property Search <FontAwesomeIcon icon={faSearch} size="1x"/></h5>
                <Row className="font-weight-bold text-nowrap" style={{fontSize: 'larger'}}>
                    <Col sm="12" md={{size: 3, offset: 2}}>
                        <Link to="/residential">
                            <img alt="Palm Island Specialist" src={`${publicUrl}/images/res_small.png`} className="img-fluid pr-1" />
                            All Residential
                        </Link>
                    </Col>
                    <Col sm="12" md={3}>
                        <Link to="/land" className="pl-4">
                            <img alt="Palm Island Specialist" src={`${publicUrl}/images/land_small.png`} className="img-fluid pr-1" />
                            All Land
                        </Link>
                    </Col>
                    <Col sm="12" md={4}>
                        <Link to="/listings" className="pl-4">
                            <img alt="Palm Island Specialist" src={`${publicUrl}/images/residentialPre.png?w=80`} className="img-fluid pr-1" />
                            All Kevin Mackin
                        </Link>
                    </Col>
                </Row>
                <hr/>
            </div>
            <Form className="pt-1" style={{width: "70%", margin: "0 auto"}} >
                <Row form>
                    <Col md={4}>
                        <FormGroup>
                            <Label className="font-weight-bold">Property Type</Label>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="radio2" defaultChecked onClick={() => this.setState({type: 'Residential'})} />{' '}
                                    Residential
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="radio2" onClick={() => this.setState({type: 'Land'})}  />{' '}
                                    Land
                                </Label>
                            </FormGroup>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <p className="font-weight-bold">Price Range</p>
                            <DropDownList data={this.prices} value={this.state.priceRange} onChange={(e) => this.setState({priceRange: e.target.value})}/>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup check>
                            <Label check className="font-weight-bold">
                                <Input type="checkbox" onClick={(e) => this.setState({waterFront: e.target.checked})} />{' '}
                                Water Front
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <Row form>
                    <Col md={4}>
                        <FormGroup>
                            <p className="font-weight-bold">Min. Bedrooms ({Math.round(this.state.minBedrooms)})</p>
                            <Slider
                                buttons={false}
                                step={1}
                                value={this.state.minBedrooms}
                                min={1}
                                max={10}
                                onChange={(e) => this.setState({minBedrooms: e.value})}
                            >
                                <SliderLabel title={1} position={1} onClick={() => this.setState({minBedrooms: 1})}>1</SliderLabel>
                                <SliderLabel title={3} position={3} onClick={() => this.setState({minBedrooms: 3})}>3</SliderLabel>
                                <SliderLabel title={5} position={5} onClick={() => this.setState({minBedrooms: 5})}>5</SliderLabel>
                                <SliderLabel title={7} position={7} onClick={() => this.setState({minBedrooms: 7})}>7</SliderLabel>
                                <SliderLabel title={10} position={10} onClick={() => this.setState({minBedrooms: 10})}>10+</SliderLabel>
                            </Slider>
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <p className="font-weight-bold">Min. Bathrooms ({Math.round(this.state.minBathrooms)})</p>
                            <Slider
                                buttons={false}
                                step={1}
                                value={this.state.minBathrooms}
                                min={1}
                                max={5}
                                onChange={(e) => this.setState({minBathrooms: e.value})}
                            >
                                <SliderLabel title={1} position={1} onClick={() => this.setState({minBathrooms: 1})}>1</SliderLabel>
                                <SliderLabel title={2} position={2} onClick={() => this.setState({minBathrooms: 2})}>2</SliderLabel>
                                <SliderLabel title={3} position={3} onClick={() => this.setState({minBathrooms: 3})}>3</SliderLabel>
                                <SliderLabel title={4} position={4} onClick={() => this.setState({minBathrooms: 4})}>4</SliderLabel>
                                <SliderLabel title={5} position={5} onClick={() => this.setState({minBathrooms: 5})}>5+</SliderLabel>
                            </Slider>
                        </FormGroup>
                    </Col>
                </Row>
                <div className="mt-4 text-center">
                    <Button type="button" color="primary" onClick={this.SearchProperties}>
                        Search Properties...
                        { posting &&
                            <Spinner className="ml-2" size="sm"/>
                        }
                    </Button>

                </div>
            </Form>
            <hr/>
            <div>
                { featuredPres && featuredPres.length > 0 && !posting &&
                    <Fade appear={true}>
                        <FeaturedListings usage="search"></FeaturedListings>
                    </Fade>
                }
                { featuredPres && featuredPres.length === 0 && !posting &&
                    <div className="text-center p-3 w-100" style={{backgroundColor: 'lightgray'}}>No Results Found</div>
                }
            </div>
        </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Search.jsx